import React, { useEffect, useState } from "react";
import {
  Button,
  Input,
  Modal,
  message,
  Table,
  Typography,
  Popconfirm,
  Tooltip,
} from "antd";
import { LinkOutlined } from "@ant-design/icons";
import { translate } from "../../locale";
import SectionLoader from "../Loaders/SectionLoader";
import ProtocolServices from "../../services/ProtocolServices";

const { Search } = Input;

const { Title } = Typography;

const AssociateSurveyUser = ({ username, visible, onComplete, onCancel }) => {
  const [loading, setLoading] = useState(true);
  const [active, setActive] = useState(false);
  const [error, setError] = useState("");
  const [data, setData] = useState(null);
  const [filteredData, setFilteredData] = useState(null);

  const columns = [
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <div className="flex space-x-4 justify-center">
          <Popconfirm
            title={
              <>
                {translate(`¿Asociar la autoevaluación "${record.title}"`)}
                <br />
                {translate(`con el usuario  "${username}"?`)}
              </>
            }
            okText="Si"
            cancelText="No"
            onConfirm={() => {
              associate(record);
            }}
          >
            <Tooltip title={translate("Asociar")} color="blur">
              <Button
                type="text"
                icon={<LinkOutlined />}
                size="small"
                className="border-0"
              />
            </Tooltip>
          </Popconfirm>
        </div>
      ),
      width: 100,
    },
    {
      title: translate("Título"),
      dataIndex: "title",
      key: "title",
    },
  ];

  useEffect(() => {
    if (visible !== null) {
      setActive(visible);
      if (visible === true) {
        loadData();
      }
    }
  }, [visible]);

  const loadData = async () => {
    setLoading(true);
    try {
      const response = await ProtocolServices.getSurveys();
      if (response.status >= 200 && response.status < 300) {
        setData(response.data.survey);
        setFilteredData(response.data.survey);
      }
    } catch (e) {
      console.log(e);
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  const onSearch = (value) => {
    setFilteredData(
      data.filter(
        (i) => i.title.toLowerCase().indexOf(value.toLowerCase()) > -1
      )
    );
  };

  const handleCancel = () => {
    setActive(false);
    if (onCancel) {
      onCancel();
    }
  };

  const associate = async (survey) => {
    setLoading(true);
    setError("");
    try {
      const data = {
        survey: parseInt(survey.id),
        username: username,
      };
      const res = await ProtocolServices.assignSurveyToUser(data);

      if (
        res.status >= 200 &&
        res.status < 300 &&
        res.data &&
        res.data.survey_user !== undefined
      ) {
        message.success(
          translate(
            "La {0} se guardó exitosamente.",
            translate("autoevaluación")
          )
        );
      }
      if (onComplete) {
        onComplete();
      }
      setLoading(false);
    } catch (e) {
      console.log(e);
      setError(e.message);
      setLoading(false);
    }
  };

  return (
    <Modal
      open={active}
      title={translate("Asociar autoevaluación")}
      onOk={null}
      onCancel={handleCancel}
      footer={false}
      bodyStyle={{ maxHeight: window.innerHeight - 240, overflow: "scroll" }}
    >
      <Title level={4}>{translate("Buscar autoevaluación")}</Title>

      <Search
        placeholder={translate("Buscar por título")}
        allowClear
        size="large"
        name="term"
        onSearch={onSearch}
        loading={loading}
        className="max-w-sm mb-6"
        enterButton={translate("Buscar")}
      />

      <Table dataSource={filteredData} columns={columns} rowKey={(i) => i.id} />
      {loading && <SectionLoader />}
    </Modal>
  );
};

export default AssociateSurveyUser;
